export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/banque-misr-logo.4f7ba79c.svg","height":330,"width":800,"blurWidth":0,"blurHeight":0};